// extracted by mini-css-extract-plugin
module.exports = {"suggestionsList":"DeviceSearch_suggestionsList__2XVAh","suggestionHighlighted":"DeviceSearch_suggestionHighlighted__2iZei"};